import * as React from "react"

const BulbIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4473 25.8152C12.2477 25.8152 12.0813 25.6432 12.0647 25.4367C11.7319 21.497 10.5008 19.6561 9.41945 18.0045C8.53771 16.697 7.78906 15.5443 7.78906 13.6862C7.78906 9.33352 11.2162 5.80664 15.4086 5.80664C19.6177 5.80664 23.0449 9.33352 23.0449 13.6862C23.0449 15.5443 22.2796 16.6798 21.4145 17.9873C20.3164 19.6045 19.0853 21.4626 18.7526 25.4367C18.736 25.6604 18.553 25.8324 18.3367 25.8152C18.1204 25.7808 17.9707 25.5916 17.9873 25.3851H12.83C12.8466 25.5916 12.6969 25.7808 12.4806 25.8152C12.464 25.8152 12.464 25.8152 12.4473 25.8152Z"
      fill="#1BBD77"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0259 30.6663H14.7948C13.2975 30.6663 12.0664 29.3932 12.0664 27.8276V25.4018C12.0664 25.1781 12.5821 25.2298 12.7984 25.2298C14.8385 25.2298 18.0223 25.2298 18.0223 25.2298C18.2386 25.2298 18.7543 25.1781 18.7543 25.4018V27.8276C18.7543 29.3932 17.5399 30.6663 16.0259 30.6663Z"
      fill="#008761"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.78499 13.8076C9.56871 13.8076 9.40234 13.6356 9.40234 13.4119C9.40234 9.98827 12.0975 7.20117 15.4082 7.20117C15.6244 7.20117 15.8074 7.37321 15.8074 7.59687C15.8074 7.82053 15.6244 7.99257 15.4082 7.99257C12.53 7.99257 10.1843 10.4356 10.1843 13.4119C10.1843 13.6356 10.0013 13.8076 9.78499 13.8076Z"
      fill="#00A978"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.41 4.75764C15.1937 4.75764 15.0273 4.5856 15.0273 4.36194V1.72968C15.0273 1.50603 15.1937 1.33398 15.41 1.33398C15.6263 1.33398 15.8093 1.50603 15.8093 1.72968V4.36194C15.8093 4.5856 15.6263 4.75764 15.41 4.75764Z"
      fill="#008761"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9493 6.306C20.8827 6.306 20.8162 6.2888 20.7496 6.23718C20.5666 6.13396 20.5001 5.8931 20.6165 5.70385L21.8809 3.41568C21.9974 3.22643 22.2303 3.15761 22.4133 3.26084C22.5963 3.38127 22.6628 3.62213 22.563 3.81138L21.282 6.09955C21.2154 6.21998 21.0824 6.306 20.9493 6.306Z"
      fill="#008761"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.992 10.4858C24.8589 10.4858 24.7258 10.4169 24.6593 10.2793C24.5595 10.0901 24.6094 9.8492 24.809 9.72877L27.0051 8.42124C27.1881 8.30081 27.421 8.36963 27.5374 8.55888C27.6372 8.76533 27.5873 9.00619 27.3877 9.10941L25.1917 10.4341C25.1251 10.4686 25.0586 10.4858 24.992 10.4858Z"
      fill="#008761"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0179 16.1976H26.4725C26.2562 16.1976 26.0898 16.0256 26.0898 15.8019C26.0898 15.5783 26.2562 15.4062 26.4725 15.4062H29.0179C29.2342 15.4062 29.4172 15.5783 29.4172 15.8019C29.4172 16.0256 29.2342 16.1976 29.0179 16.1976Z"
      fill="#008761"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.88668 6.306C9.75359 6.306 9.6205 6.21998 9.55395 6.09955L8.27293 3.81138C8.17311 3.62213 8.23966 3.38127 8.42266 3.26084C8.60566 3.15761 8.83857 3.22643 8.95503 3.41568L10.2194 5.70385C10.3359 5.8931 10.2693 6.13396 10.0863 6.23718C10.0198 6.2888 9.95323 6.306 9.88668 6.306Z"
      fill="#008761"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82889 10.4858C5.77898 10.4858 5.71244 10.4686 5.64589 10.4341L3.43322 9.10941C3.25021 9.00619 3.18367 8.76533 3.30012 8.55888C3.39994 8.36963 3.63286 8.30081 3.8325 8.42124L6.02853 9.72877C6.21153 9.8492 6.27808 10.0901 6.17826 10.2793C6.09508 10.4169 5.97862 10.4858 5.82889 10.4858Z"
      fill="#008761"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.34602 16.1976H1.80061C1.58434 16.1976 1.41797 16.0256 1.41797 15.8019C1.41797 15.5783 1.58434 15.4062 1.80061 15.4062H4.34602C4.56229 15.4062 4.7453 15.5783 4.7453 15.8019C4.7453 16.0256 4.56229 16.1976 4.34602 16.1976Z"
      fill="#008761"
    />
  </svg>
)
export default BulbIcon
